import {FindAddressResponse, RetrieveAddressResponse} from '../types/loqate'

interface LoqateOptions {
  key: string
  countryCode?: string
  limit?: number
}

export class Loqate {
  private readonly options: LoqateOptions

  private static RETRIEVE_BASE_URL =
    'https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3ex.ws'

  private static FIND_BASE_URL =
    'https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3ex.ws'

  constructor(options: LoqateOptions) {
    this.options = {
      ...options,
      countryCode: options.countryCode ?? 'GBR',
      limit: options.limit ?? 7,
    }
  }

  public async searchAddresses(searchText: string, container?: string) {
    const {key, countryCode, limit} = this.options

    const addresses: Response = await fetch(
      `${Loqate.FIND_BASE_URL}?Key=${key}&Text=${encodeURIComponent(searchText)}&Container=${
        container ? encodeURIComponent(container) : ''
      }&Origin=&Countries=${countryCode}&Datasets=&Limit=${limit}&Filter=&Language=en&$block=true&$cache=true`
    )

    const parsed: FindAddressResponse = await addresses.json()

    return parsed
  }

  public async getAddressDetails(addressId: string) {
    const {key} = this.options

    const details: Response = await fetch(
      `${Loqate.RETRIEVE_BASE_URL}?Key=${key}&Id=${encodeURIComponent(
        addressId
      )}&Source=&$cache=true`
    )
    const parsed: RetrieveAddressResponse = await details.json()

    return parsed.Items[0]
  }
}
